/**
 * What the dashboard shows while it is released back to its owner one stage at a time.
 *
 * Every screen still exists and the API is unchanged; this only decides what the browser can reach.
 * A key is either a navigation key from `navigation.ts`, which releases the sidebar entry and its
 * route together, or a dotted key for something that lives inside another screen. Home-page
 * widgets have no keys of their own: each one appears once the screen it summarises is released,
 * so the landing page never links somewhere that answers 404.
 *
 * The plan, and which stage is current, lives in RELEASE-PLAN.md beside the repositories.
 * Releasing a stage is uncommenting its line.
 */
export const RELEASED: ReadonlySet<string> = new Set<string>([
  // Stage 1 — getting in: sign-in, activation, home, language, sign out. No menu entries.
  // Stage P — the Laseera platform console, brought forward at the owner's request (CR-3).
  'tenants', 'invoices', 'featureFlags', 'platformSupport', 'platformAudit',
  // Stage 2 — clinic setup. Doctors' hours joined it on 2026-10-09 (D-2, CR-19).
  'branches', 'staff', 'doctorHours', 'policies', 'branding',
  // Stage 3 — what you sell.
  'catalog', 'packages',
  // Stage 4 — patients and appointments.
  'patients', 'dayBoard', 'worklists',
  // Released with Stage 4 on 2026-10-11 (CR-29).
  'appointments',
  // Stage 5 — clinical. The patient profile's Clinical tab was hidden again on 2026-10-11 at the
  // owner's request (CR-31):  'patients.clinical',
  'consents', 'aftercare',
  // Stage 6 — money.
  'checkout', 'sales', 'refunds', 'expenses', 'statements',
  // Stage 7 — stock & machines:  'inventory', 'machines',
  // Stage 8 — messages:          'notifications', 'chat', 'broadcasts', 'shell.notificationBell',
  // Stage 9 — reports & control: 'reports', 'audit', 'supportGrants',
]);

export function isReleased(key: string): boolean {
  return RELEASED.has(key);
}
